import React from 'react';
import { StyledNumbersRowSingle } from './StyledNumbersRowSingle';

const NumbersRowSingle = ({ extraMargin, newHome, children }) => {
  return (
    <React.Fragment>
      {
        <StyledNumbersRowSingle newHome={newHome} className={extraMargin ? "row--single extra--margin" : "row--single"}>
          {children}
        </StyledNumbersRowSingle>
          
      }
    </React.Fragment>
  );
};

export default NumbersRowSingle;
